
var espresso = espresso || {};
( function () {
	'use strict';

	$(document).ready(function () {
		(function () {
			var input = $('#ServiceCatalog_NewProduct_ShortDescription');
			input.on('keyup', function (e) {
				$('#characters').text(160 - e.target.value.length);
			});
		}());

		// when user clicks on accept terms the checkboxes auto checks
		(function () {
			var acceptedTop = $('#EcomOrderCustomerAcceptedTop');
			var acceptedBottom = $('#EcomOrderCustomerAccepted');

			if (acceptedTop.length && acceptedBottom.length) {
				var acceptTermsBtn = $('#accept-terms-btn');
				acceptTermsBtn.click(function () {
					acceptedBottom.prop("checked", true);
					acceptedTop.prop("checked", true);
				});
			}
		})();
		

	})
}());